import { render, staticRenderFns } from "./ModuleBrandNewForm.vue?vue&type=template&id=6ff7624d&"
import script from "./ModuleBrandNewForm.vue?vue&type=script&lang=js&"
export * from "./ModuleBrandNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports